import { render, staticRenderFns } from "./StaffHeader.vue?vue&type=template&id=7d461e64&scoped=true&"
import script from "./StaffHeader.vue?vue&type=script&lang=js&"
export * from "./StaffHeader.vue?vue&type=script&lang=js&"
import style0 from "./StaffHeader.vue?vue&type=style&index=0&id=7d461e64&scoped=true&lang=scss&"
import style1 from "./StaffHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d461e64",
  null
  
)

export default component.exports